export default __webpack_public_path__ + "pgnv-assets/b9d72faea1809902a5303aa09b615472.png";